import(/* webpackMode: "eager" */ "/app/src/app/[lang]/not-found.tsx");
